import { Input } from '@/core/components/ui/input';
import { Label } from '@/core/components/ui/label';
import { AlertCircle } from 'lucide-react';
import { isRtlLanguage } from '../../types/translation-types';
import { cn } from '@/core/lib/utils';

interface LanguageInputProps {
  languageCode: string;
  languageName: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  showWarning?: boolean;
  disabled?: boolean;
  className?: string;
}

export function LanguageInput({
  languageCode,
  languageName,
  value,
  onChange,
  required = false,
  showWarning = false,
  disabled = false,
  className,
}: LanguageInputProps) {
  const isRtl = isRtlLanguage(languageCode);

  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex items-center gap-2">
        <Label htmlFor={`lang-${languageCode}`} className="text-sm font-medium">
          {languageName} ({languageCode.toUpperCase()})
          {required && <span className="text-red-500 ml-1">*</span>}
        </Label>
        {showWarning && !value && (
          <AlertCircle className="h-4 w-4 text-amber-500" />
        )}
      </div>
      <Input
        id={`lang-${languageCode}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        dir={isRtl ? 'rtl' : 'ltr'}
        className={cn(
          isRtl && 'text-right',
          !value && showWarning && 'border-amber-300'
        )}
        placeholder={`Enter ${languageName} translation...`}
      />
    </div>
  );
}
